import React from "react"
import { Div, Button } from "atomize"
import PropTypes from "prop-types"
import { faCreativeCommonsPd } from "@fortawesome/free-brands-svg-icons"
import { theme } from "./settings/config"

InlineCheckboxButtons.propTypes = {
	activeBg: PropTypes.string,
	activeTextColor: PropTypes.string,
	elements: PropTypes.array,
	handleClick: PropTypes.func,
	inactiveBg: PropTypes.string,
	p: PropTypes.any,
	selectedElem: PropTypes.any,
	setValueInsteadIndex: PropTypes.bool,
}

InlineCheckboxButtons.defaultProps = {
	inactiveBg: "gray",
	activeBg: "gunmetal_fill",
	activeTextColor: "text_alt",
	selectedElem: null,
	elements: [],
	handleClick: null,
	setValueInsteadIndex: false,
	p: null,
}

function InlineCheckboxButtons({ elements, selectedElem, activeBg, handleClick, p, valueToSet }) {
	return (
		<Div d="flex" p={p} m={{ b: "1rem" }} overflow="auto">
			{elements.map((elem, index) => {
				return (
					<Button
						style={{ whiteSpace: "nowrap" }}
						key={index}
						p={{ x: "1rem" }}
						m={{ r: "0.75rem" }}
						h="3.5rem"
						bg={selectedElem == elem[valueToSet].toString() ? activeBg : "surface"}
						rounded="20px"
						textWeight={selectedElem == elem[valueToSet].toString() && "bold"}
						textSize="subheader"
						textColor={selectedElem == elem[valueToSet].toString() ? theme.colors.white : "black"}
						onClick={() =>
							selectedElem !== elem[valueToSet].toString() &&
							handleClick(elem[valueToSet])
						}>
						{elem.text}
					</Button>
				)
			})}
		</Div>
	)
}

export default InlineCheckboxButtons
